import { IconNokkelhull, IconNytNorge, IconPant2Kr, IconPant3Kr } from "@tine/designsystem-icons/sharp";
import isNil from "lodash-es/isNil";
import { observer } from "mobx-react-lite";

import { type Badge, PageType } from "../common/types/productTypes";

type BadgesProps = {
   badges: Badge[];
   page: PageType;
};
const badgeIconMap = {
   nokkelhullet: IconNokkelhull,
   nyt_norge: IconNytNorge,
   pant_2kr: IconPant2Kr,
   pant_3kr: IconPant3Kr
};

const Badges = ({ badges, page }: BadgesProps) => {
   if (isNil(badges) || badges.length === 0) {
      return null;
   }

   const iconClass = page === PageType.ProductDetailsPage ? "w-10 h-10" : "w-8 h-8";
   const outerClass = page === PageType.ProductDetailsPage ? "right-[-7px] top-7 w-10" : "-right-[3px] top-7 w-8";
   const visibleBadges = badges.slice(0, 3); // Show max 3 badges

   return (
      <div className={outerClass}>
         {visibleBadges.map((b) => {
            const IconComponent = badgeIconMap[b.key];
            return IconComponent ? <IconComponent key={b.key} className={iconClass} /> : null;
         })}
      </div>
   );
};

export default observer(Badges);
